/**
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Pickup Order component. The component displays the details of pickup orders .
 * 
 * App Name: MMWeb
 * Author: Aparna
 * Created Date: 7/8/20201
 */
import React, { Component } from 'react';
/**
 * Ref: NC_PC_02
 * Importing the action and store file and set to an object.
 */
import * as PickingAction from '../actions/MMPickupOrderAction';
import PickingStore from '../stores/MMPickupOrderStore';
import * as CookieService from '../CookieService';
import SDIConstants from '../SDIConstants';
import swal from 'sweetalert';
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next'
import * as MenuAction from '../actions/MenuAction';
//WW-773_PC_02 -Aparna
import ReactPaginate from 'react-paginate';
import Select from 'react-select';
let currentPagePath;
//import { Alert } from '@material-ui/lab';
//import * as MenuAction from '../actions/MenuAction';
//window.jQuery = $;
//require("jquery-toast-plugin/dist/jquery.toast.min.js");
//require("jquery-toast-plugin/dist/jquery.toast.min.css");
//let qckKeycounter = 0;
//let type = 0;
//let rmvAttachindex = -1;
//let currentPagePath;
//let Session_ZEUSNOCATALOGSITE;
class MMPickupOrderComponent extends Component {
    /**
    * Ref: NC_PC_04
    * Define the constructor that takes props as parameter
    * 
    * @param props
    */
    constructor(props) {
        super(props);
        // this.PageLoadResponse = this.PageLoadResponse.bind(this);
        //  this.SubmitButtonClickResponse = this.SubmitButtonClickResponse.bind(this);
        /**
       * Ref: NC_PC_05
       * Set the initial values of the state variables
       */
        this.state = {
            PageLoadData: [],
            PageLoadDataBP: [],
            Totalcount: 0,
            SummaryData: [],
            Pick: "",
            OrderNo: "",
            LineNo: "",
            ItemId: "",
            Pickpopup: [], isFavorited: false,
            //[10/28/22], PC_WW-529_1, Dhevanesam R
            AssigntoList: [],
            PageNo: 1, pageCount: 0, RecCount: 200, //WW-773_PC_03 -Aparna
            OrderDetails: [],
            SearchBy: "All", STrDisplayName: "All", srchTxt: "", OrderDetails: [], AssignToDD: [], OrgOrderDetails: [] //PC_CPW_261_01 - Vishwa S
        }
    };
    /**
   * Ref: PP_PC_04
   * componentwillMount method will be first method which will be invoked
   * 
   */

    componentDidMount() {
        CookieService.updateLocalStorageValues("Session_PageName", window.location.pathname);
        //[2/17/2023, PC_WW-614_APP_01, Dhevanesam R]
        let cribID = "";
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != null && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != undefined) {
            cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        }
        if (cribID.trim() != "") {
            let BO = {
                UserId: CookieService.getLocalStorageValues("Session_UserID"),
                BusinessUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                //WBW-10 (Picking - capture images from SOLR search)
                userBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                punchinSessionID: "",
                Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
                Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                CurrentPage_Url: "/SDIXZEUS/pickup",
                Session_PARTLIST: CookieService.getLocalStorageValues("Session_PARTLIST"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_CARTFAIL: "N",
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                //Location: CookieService.getLocalStorageValues("LOCATION") != null ? CookieService.getLocalStorageValues("Location").substring(0, 2) : "",
                Location: CookieService.getLocalStorageValues("Session_STATE") != null ? CookieService.getLocalStorageValues("Session_STATE") : "",
                cribID: cribID
            }
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            PickingAction.PickingPageLoadAction(BO)
            currentPagePath = this.props.location.pathname;
            currentPagePath = currentPagePath.indexOf("?") >= 0 ? currentPagePath.split("?")[0] : currentPagePath;
            let getFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            };
            PickingAction.getCurrentFavPage(getFavPageBO);

            /**
      * Ref: PP_PC_07
      * componentwillMount method will be first method which will be invoked
      * 
      */
            PickingStore.on('PickingPageLoad', this.PageLoadResponse.bind(this));
            /**
          * Ref: PP_PC_10
          * componentwillMount method will be first method which will be invoked
          */
            PickingStore.on('SubmitResponse', this.SubmitButtonClickResponse);
            PickingStore.on('ChangeAssigntoResponse', this.ChangeAssigntoResponse);
            // PickingStore.on('geo', this.geotry);
            PickingStore.on('favpage', this.loadFavPageResponse.bind(this));
            PickingStore.on('updateFavPage', this.updateFavPageResponse.bind(this));
        }
        else {
            if (CookieService.getLocalStorageValues("HideMobility") && CookieService.getLocalStorageValues("HideMobility").toUpperCase() == "TRUE") {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "No crib has been selected. Please contact the admin/manager to assign a crib"
                });
                this.props.history.push({
                    pathname: `/homepage`
                });
            }
            else {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: "Please select crib from user profile"
                });
                this.props.history.push({
                    pathname: `/profile`,
                    state: { origin: 'Inventory' }
                });
            }
            return;
        }

    }
    componentWillUnmount() {

        // PickingStore.removeListener('PickingPageLoad', this.PageLoadResponse);
        // PickingStore.removeListener('SubmitResponse', this.SubmitButtonClickResponse);
    }

    loadFavPageResponse = () => {
        let favPageResponse = JSON.parse(PickingStore.currentFavPageResponse);
        if (favPageResponse.length > 0) {
            favPageResponse = favPageResponse[0];
            this.setState({ isFavorited: true, Page_ID: favPageResponse.PAGE_ID });
        };
    };
    updateFavPageResponse = () => {
        if (PickingStore.updateFavPageResponse.updateType == 1) {
            let response = JSON.parse(PickingStore.updateFavPageResponse.responseStr)[0];
            if (response.is_Success == "True") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: true, Page_ID: response.Page_ID });
                MenuAction.toastMessage(1);
            }
        } else {
            let response = JSON.parse(PickingStore.updateFavPageResponse.responseStr)[0];
            if (response.success == "true") {
                $(`#${SDIConstants.SDILoader}`).addClass('hide');
                this.setState({ isFavorited: false });
                MenuAction.toastMessage(2);
            }
        }
        //this.refreshMenu();
    };
    handleFavorite = (event) => {
        this.setState({ isFavorited: event.target.checked });
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        if (event.target.checked == true) {
            let insertFavPageBO = {
                Session_USERID: CookieService.getLocalStorageValues("Session_UserID"),
                pageURL: currentPagePath.toLowerCase(),
                pageTitle: "Picking Assign To",
                Session_BUSUNIT: CookieService.getLocalStorageValues("Session_BUSUNIT")
            }
            PickingAction.insertFavPage(insertFavPageBO)
        } else {
            let deleteFavPageBO = {
                Page_ID: this.state.Page_ID
            }
            PickingAction.deleteFavPage(deleteFavPageBO)
        }
    };
    /**
     * PC_PC_07
     * */
    //[10/28/22], PC_WW-529_3, Dhevanesam R
    PageLoadResponse = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let PageLoad = JSON.parse(PickingStore.PageLoadData);
        let datacount = 0;
        let pageData = [];
        datacount = PageLoad.dataTable.length
        if (PageLoad.dataTable) {
            if (PageLoad.dataTable.length > 0) {
                pageData = PageLoad.dataTable
                //// PageLoad.dataTable.map((val, ind) => {
                ////    let Data = {
                ////        Order_no: val.ORDER_NO,
                ////        Inv_item_id: val.INV_ITEM_ID,
                ////        ImageURL: val.IMAGEURL,
                ////        Storage_Area: val.STORAGE_AREA,
                ////        Stor_level_1: val.STOR_LEVEL_1,
                ////        Stor_level_2: val.STOR_LEVEL_2,
                ////        Stor_level_3: val.STOR_LEVEL_3,
                ////        Stor_level_4: val.STOR_LEVEL_4,
                ////        Qty_requested: val.QTY_REQUESTED,
                ////        Descr254: val.DESCR254,
                ////        Receiver_id: val.RECEIVER_ID,
                ////        Confirmed_flag: val.CONFIRMED_FLAG,
                ////        Isa_cust_notes: val.ISA_CUST_NOTES,
                ////        Order_int_line_no: val.ORDER_INT_LINE_NO,
                ////        Qty_picked: val.QTY_PICKED,
                ////        Pick_confirm_dttm: val.PICK_CONFIRM_DTTM,
                ////        Begindttm: val.BEGINDTTM,
                ////        Demand_line_no: val.DEMAND_LINE_NO,
                ////        Sched_line_no: val.SCHED_LINE_NO,
                ////        Seq_nbr: val.SEQ_NBR,
                ////        Recv_ln_nbr: val.RECV_LN_NBR,
                ////        Demand_source: val.DEMAND_SOURCE,
                ////        qty: parseInt(val.QTY_REQUESTED),
                ////        Business_unit: val.BUSINESS_UNIT,
                ////        CribID: val.CribIdentifier,
                ////        AssignTo: val.ASSIGNED_TO,
                ////        PreAssignTo: val.ASSIGNED_TO
                ////    }
                ////    pageData.push(Data)
                ////})
            }
        }
        let AssigntoDT = PageLoad.AssigntoDT
        let AssigntoDTVal = []
        if (AssigntoDT != null && AssigntoDT != undefined) {
            if (AssigntoDT.length > 0) {
                AssigntoDTVal = AssigntoDT.filter((v, i, a) => a.findIndex(t => (t.ISA_EMPLOYEE_ID.trim().toUpperCase() === v.ISA_EMPLOYEE_ID.trim().toUpperCase())) === i)
            }
        }
        let pageDataResponse = []
        pageDataResponse = pageData;
        pageDataResponse.forEach((value, index) => {
            
            value.SubmitShow = false;
            value.ButtonDisable = true;
            value.qty = parseInt(value.QTY_REQUESTED)
            //WW - 569 To add WO and change assign to name in the picking panel - Deepthi
            value.Priority = "";
            if (value.ISA_CUST_PRIORITY == null || value.ISA_CUST_PRIORITY.trim() == "") {
                value.Priority = value.PRIORITY_NBR;
            }
            else if (value.DESCR != undefined) {
                if (value.DESCR != null && value.DESCR != "") {
                    value.Priority = value.ISA_CUST_PRIORITY + " - " + value.DESCR;
                }
                else {
                    value.Priority = value.ISA_CUST_PRIORITY + " - ";
                }
            }
            if (value.ASSIGNED_TO != null && value.ASSIGNED_TO != undefined && value.ASSIGNED_TO != "" && value.ASSIGNED_TO != " ") {
                if (CookieService.getLocalStorageValues("Session_UserID") == value.ASSIGNED_TO) {
                    value.SubmitShow = true;
                    value.ButtonDisable = false;
                }
                else {
                    
                    pageDataResponse.forEach((val, ind) => {
                        if (value.ORDER_NO == val.ORDER_NO) {
                            val.SubmitShow = false;
                            val.ButtonDisable = true;
                        }
                    });
                }
            }
        });
        //WW-773_PC_06 -Aparna
        let totalcount = 0;
        let count = 0;
        let loc = []
        loc = pageDataResponse.filter((v, i, a) => a.findIndex(t => (t.ORDER_NO.trim().toUpperCase() === v.ORDER_NO.trim().toUpperCase())) === i)
        if (pageDataResponse != null && pageDataResponse != undefined) {
            if (loc.length > 0) {
                totalcount = loc.length
                count = parseFloat(totalcount) / 200 //PC_CPW_261_04 -Vishwa S
            }
        }

        let AssignToDDValue = [
            {
                value: "0",
                label: "Select User"
            },
            {
                value: "SKIPPED",
                label: "SKIPPED"
            }
        ];
        AssigntoDTVal.map((val, index) => {
            let localArray = {
                value: val.ISA_EMPLOYEE_ID,
                label: val.ISA_USER_NAME + " - " + val.ISA_EMPLOYEE_ID
            }
            AssignToDDValue.push(localArray)
        });

        this.setState({
            PageLoadData: pageDataResponse, PageLoadDataBP: PageLoad, OrderDetails: loc,
            datacount, AssigntoList: AssigntoDTVal, pageCount: count, Totalcount: totalcount, AssignToDD: AssignToDDValue, OrgOrderDetails: loc
        });

        console.log("PickingPageLoad", pageData)
    }
    //[10/28/22], PC_WW-529_5, Dhevanesam R
    handleAssignto = (e, val) => {
        let dataBO = [];
        let prevAssignTo = "";
        let ChangeAssigntoBOList = [];
        dataBO = this.state.PageLoadData.filter((x) => x.ORDER_NO == val.ORDER_NO)

        let { PageLoadData } = this.state;
        if (e.value != '' && e.value != null && e.value != undefined) {
            dataBO.forEach((valuedataBO, indexdataBO) => {
                PageLoadData.forEach((valuePage, indexPage) => {
                    if (valuedataBO.ORDER_NO == valuePage.ORDER_NO) {
                        prevAssignTo = valuePage.ASSIGNED_TO == "0" ? "" : valuePage.ASSIGNED_TO
                        valuePage.ASSIGNED_TO = e.value
                    }
                });
            });
        }

        dataBO.map((x, i) => {
            let loc = {
                Order_int_line_no: x.ORDER_INT_LINE_NO,
                Assignto: e.value,
                Order_no: x.ORDER_NO,
                Inv_item_id: x.INV_ITEM_ID,
                Business_unit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                Old_assign_to: prevAssignTo
            }
            ChangeAssigntoBOList.push(loc)
        })
        let ChangeAssigntoButtonClickBO = {
            ChangeAssigntoBOList: ChangeAssigntoBOList,
            CribID: CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT"),
            UserID: CookieService.getLocalStorageValues("Session_UserID"),
            WebsiteID: CookieService.getLocalStorageValues("Session_WEBSITEID")
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        PickingAction.ChangeAssigntoButtonClick(ChangeAssigntoButtonClickBO)


        this.setState(
            { PageLoadData: PageLoadData });

    }
    //[10/28/22], PC_WW-529_4, Dhevanesam R
    BindAssignTo = () => {
        return this.state.AssigntoList.map((iresult, index) => {
            if (iresult != null && iresult != undefined) {
                //WW - 569 To add WO and change assign to name in the picking panel - Deepthi
                return (<option key={iresult.ISA_EMPLOYEE_ID} value={iresult.ISA_EMPLOYEE_ID}> {iresult.ISA_USER_NAME} - {iresult.ISA_EMPLOYEE_ID}</option>)
            }
        });

    }
    //[10/28/22], PC_WW-529_12, Dhevanesam R
    ChangeAssigntoResponse = () => {
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let ChangeAssigntoResponse = JSON.parse(PickingStore.ChangeAssigntoResponse);
        let Message = []
        Message = ChangeAssigntoResponse.Message
        if (Message != null && Message != undefined) {
            if (Message.length > 0) {
                swal({
                    allowOutsideClick: false,
                    closeOnClickOutside: false,
                    text: Message[0].AlertMsg
                });
            }
        }
        let pageDataResponse = []
        pageDataResponse = this.state.PageLoadData;
        pageDataResponse.forEach((value, index) => {
            
            value.SubmitShow = false;
            value.ButtonDisable = true;
            if (value.ASSIGNED_TO != null && value.ASSIGNED_TO != undefined && value.ASSIGNED_TO != "" && value.ASSIGNED_TO != " ") {
                if (CookieService.getLocalStorageValues("Session_UserID") == value.ASSIGNED_TO) {
                    value.SubmitShow = true;
                    value.ButtonDisable = false;
                }
                else {
                    
                    pageDataResponse.forEach((val, ind) => {
                        if (value.ORDER_NO == val.ORDER_NO) {
                            val.SubmitShow = false;
                            val.ButtonDisable = true;
                        }
                    });
                }
            }
        });
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        this.setState({
            PageLoadData: pageDataResponse
        })
    }
    /**
    * PC_PC_11
    * */
    SubmitButtonClickResponse = () => {
        //[11/2/22], Bug - 2854, Dhevanesam R
        $('#summary').modal('hide');
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        let Response = PickingStore.SubmitResponse
        console.log("Response", Response)
        if (Response == "Success") {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Submitted successfully"
            });
            //alert("submitted successfully");
            //window.location.reload();
        }
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Submition Failed"
            });
            // alert("Submition Failed");
            //window.location.reload();
        }
        //[2/17/2023, PC_WW-614_APP_01, Dhevanesam R]
        let cribID = "";
        if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != null && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != undefined) {
            cribID = CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
        }
        if (cribID.trim() != "") {
            let BO = {
                UserId: CookieService.getLocalStorageValues("Session_UserID"),
                BusinessUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                userBU: CookieService.getLocalStorageValues("Session_BUSUNIT"),
                punchinSessionID: "",
                Session_USERTYPE: CookieService.getLocalStorageValues("Session_USERTYPE"),
                Session_EMAIL: CookieService.getLocalStorageValues("Session_EMAIL"),
                Session_SDIEMP: CookieService.getLocalStorageValues("Session_SDIEMP"),
                Session_UserName: CookieService.getLocalStorageValues("Session_USERNAME"),
                Session_ACTIVEUSERS: CookieService.getLocalStorageValues("Session_ACTIVEUSERS"),
                Session_WEBSITEID: CookieService.getLocalStorageValues("Session_WEBSITEID"),
                CurrentPage_Url: "/SDIXZEUS/pickup",
                Session_PARTLIST: CookieService.getLocalStorageValues("Session_PARTLIST"),
                Session_CplusDbSQL: CookieService.getLocalStorageValues("Session_CplusDbSQL"),
                Session_MobIssuing: CookieService.getLocalStorageValues("Session_MobIssuing"),
                Session_ITEMMODE: CookieService.getLocalStorageValues("Session_ITEMMODE"),
                Session_SITEPREFIX: CookieService.getLocalStorageValues("Session_SITEPREFIX"),
                Session_CARTFAIL: "N",
                Session_USESOLRSEARCH: CookieService.getLocalStorageValues("Session_USESOLRSEARCH"),
                Session_CplusDB: CookieService.getLocalStorageValues("Session_CplusDB"),
                Session_SDICAT: CookieService.getLocalStorageValues("Session_SDICAT"),
                Session_SEARCH3M: CookieService.getLocalStorageValues("Session_SEARCH3M"),
                Session_SEARCHORONASCO: CookieService.getLocalStorageValues("Session_SEARCHORONASCO"),
                Session_SEARCHCAPP: CookieService.getLocalStorageValues("Session_SEARCHCAPP"),
                Session_SEARCHMSC: CookieService.getLocalStorageValues("Session_SEARCHMSC"),
                Session_SEARCHIMP: CookieService.getLocalStorageValues("Session_SEARCHIMP"),
                Session_SEARCHSTAUFFER: CookieService.getLocalStorageValues("Session_SEARCHSTAUFFER"),
                Session_CARTTAXEXMPTFLAG: CookieService.getLocalStorageValues("Session_CARTTAXEXMPTFLAG"),
                Location: CookieService.getLocalStorageValues("LOCATION") != null ? CookieService.getLocalStorageValues("LOCATION").substring(0, 2) : "",
                cribID: cribID
            }

            $(`#${SDIConstants.SDILoader}`).removeClass('hide');
            $('.header-arrow').removeClass('accordion-arrow-change');
            $('.content-row').addClass('d-none');
            window.scrollTo(0, 0)
            PickingAction.PickingPageLoadAction(BO)
        }
        else {
            this.props.history.push({
                pathname: `/profile`,
                state: { origin: 'Inventory' }
            });
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "Please Select Crib Id from User Profile"
            })
        }

    }
    onAccordianClick = (event, index) => {
        $(event.currentTarget).children().toggleClass('accordion-arrow-change');
        $(`#contentrow-${index}`).toggleClass('d-none');
        //$('tr').removeClass('tr-border');
        //$(event.currentTarget).parent('tr').addClass('tr-border');
    };
    /**
    * PC_PC_10
    * */
    handleQTYchange = (event, val) => {
        let ind = this.state.PageLoadData.findIndex(x => x.ORDER_NO == val.ORDER_NO && x.INV_ITEM_ID == val.INV_ITEM_ID && x.ORDER_INT_LINE_NO == val.ORDER_INT_LINE_NO)
        let { PageLoadData } = this.state;
        let { Pickpopup } = this.state;
        let pickpopuploc = [];
        let displaymsg = ""


        const re = SDIConstants.quantityRegEX;
        if (event.target.value === '' || re.test(event.target.value)) {
            PageLoadData[ind].qty = event.target.value
            if (this.state.Pickpopup.length != 0) {
                pickpopuploc = this.state.Pickpopup.filter((x) => x.orderno == val.ORDER_NO && x.itemid == val.INV_ITEM_ID && x.lineno == val.ORDER_INT_LINE_NO)
            }
            if (val.QTY_REQUESTED == event.target.value) { }
            if (pickpopuploc.length == 0 || pickpopuploc.length > 0) {
                //    if (event.target.value !="") {

                if (event.target.value == 0 || event.target.value == "") {
                    displaymsg = "Zero pick"
                }
                else if (parseInt(val.QTY_REQUESTED) > event.target.value) {
                    displaymsg = "Under pick"
                }
                else if (parseInt(val.QTY_REQUESTED) < event.target.value) {
                    displaymsg = "Over pick"
                }

                else if (parseInt(val.QTY_REQUESTED) == event.target.value) {
                    displaymsg = ""
                }
                let indx = this.state.Pickpopup.findIndex(x => x.orderno == val.ORDER_NO && x.itemid == val.INV_ITEM_ID && x.lineno == val.ORDER_INT_LINE_NO)
                if (indx != -1 && displaymsg != "") {
                    Pickpopup[indx].msg = displaymsg
                    Pickpopup[indx].qty = event.target.value

                }
                else {
                    if (displaymsg != "") {
                        let loc = {
                            orderno: val.ORDER_NO,
                            itemid: val.INV_ITEM_ID,
                            lineno: val.ORDER_INT_LINE_NO,
                            reqqty: val.QTY_REQUESTED,
                            qty: event.target.value,
                            msg: displaymsg
                        }
                        this.state.Pickpopup.push(loc)
                    }
                    else {
                        let indx = this.state.Pickpopup.findIndex(x => x.orderno == val.ORDER_NO && x.itemid == val.INV_ITEM_ID && x.lineno == val.ORDER_INT_LINE_NO)
                        this.state.Pickpopup.splice(indx, 1)
                    }
                }

                //  }
                //else if (event.target.value == 0){

                //        displaymsg = "Zero pick"

                //    if (displaymsg != "") {
                //        let loc = {
                //            orderno: val.Order_no,
                //            itemid: val.Inv_item_id,
                //            lineno: val.Order_int_line_no,
                //            reqqty: val.Qty_requested,
                //            qty: event.target.value,
                //            msg: displaymsg
                //        }
                //        this.state.Pickpopup.push(loc)
                //    }
                //}


            }
            else {
                let indx = this.state.Pickpopup.findIndex(x => x.ORDER_NO == val.orderno && x.itemid == val.INV_ITEM_ID && x.lineno == val.ORDER_INT_LINE_NO)
                this.state.Pickpopup[indx].qty = event.target.value
            }

            this.setState(PageLoadData);
            console.log("value edit", this.state.Pickpopup)
        }
        else if (event.target.value == "") {
            PageLoadData[ind].qty = this.state.PageLoadDataBP[ind].QTY_REQUESTED
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: "alert"
            });
            // alert("alert")
        }
    }
    /**
    * PC_PC_
    * */
    qtycheck = (event, val) => {
        const re = SDIConstants.quantityRegEX;
        if (val.qty === '' || re.test(val.qty)) {
            let ind = this.state.PageLoadData.findIndex(x => x.ORDER_NO == val.ORDER_NO && x.INV_ITEM_ID == val.INV_ITEM_ID && x.ORDER_INT_LINE_NO == val.ORDER_INT_LINE_NO)
            let { PageLoadData } = this.state;
            PageLoadData[ind].qty = val.qty
            if (parseInt(this.state.PageLoadDataBP[ind].QTY_REQUESTED) < val.qty) {
                //                return (<Alert severity="success" color="info">
                //                    This is a success alert — check it out!
                //</Alert>);
                //alert("Do you want to over pick the item");
                $(`#Pick_popup`).modal('show')
                this.setState({ Pick: "over pick", OrderNo: this.state.PageLoadDataBP[ind].ORDER_NO, LineNo: this.state.PageLoadDataBP[ind].ORDER_INT_LINE_NO, ItemId: this.state.PageLoadDataBP[ind].INV_ITEM_ID });
                return;
            }
            else if (val.qty == 0) {
                //alert("do u want to zero pick the item")
                $(`#Pick_popup`).modal('show')
                this.setState({ Pick: "zero pick", OrderNo: this.state.PageLoadDataBP[ind].ORDER_NO, LineNo: this.state.PageLoadDataBP[ind].ORDER_INT_LINE_NO, ItemId: this.state.PageLoadDataBP[ind].INV_ITEM_ID });
                return;
            }
            else if (parseInt(this.state.PageLoadDataBP[ind].QTY_REQUESTED) > val.qty) {
                //alert("Under pick");
                $(`#Pick_popup`).modal('show')
                this.setState({ Pick: "under pick", OrderNo: this.state.PageLoadDataBP[ind].ORDER_NO, LineNo: this.state.PageLoadDataBP[ind].ORDER_INT_LINE_NO, ItemId: this.state.PageLoadDataBP[ind].INV_ITEM_ID });
                return;
            }
            else if (parseInt(this.state.PageLoadDataBP[ind].QTY_REQUESTED) == val.qty) {
                //alert("Under pick");
                //$(`#summary`).modal('hide')
                this.DoneButtonClick(this.state.PageLoadDataBP[ind], "1")
                this.setState({ Pick: "", OrderNo: this.state.PageLoadDataBP[ind].ORDER_NO, LineNo: this.state.PageLoadDataBP[ind].ORDER_INT_LINE_NO, ItemId: this.state.PageLoadDataBP[ind].INV_ITEM_ID });
                return;
            }
            //this.setState(PageLoadData);
            //console.log("value edit", this.state.PageLoadData[ind])
        }
    }
    //Pickpopup = (button) => {
    //    let ind = this.state.PageLoadData.findIndex(x => x.Order_no == this.state.OrderNo && x.Order_int_line_no == this.state.LineNo && x.Inv_item_id == this.state.ItemId)
    //    let { PageLoadData } = this.state;
    //    if (button == "1") {
    //        let indx = this.state.PageLoadDataBP.findIndex((x) => x.Order_no == this.state.OrderNo && x.Order_int_line_no == this.state.LineNo && x.Inv_item_id == this.state.ItemId)
    //        PageLoadData[indx].qty = parseInt(this.state.PageLoadDataBP[indx].Qty_requested)
    //        this.setState(PageLoadData);
    //        $(`#Pick_popup`).modal('hide')
    //    }
    //    else {
    //        this.submitButtonClick(this.state.OrderNo,this.state.ItemId, this.state.LineNo)
    //       // $(`#summary`).modal('hide')
    //        $(`#Pick_popup`).modal('hide')

    //    }
    //}
    /**
     * PC_PC_16
     * */

    Pickpopup = (button) => {
        if (this.state.SummaryData.length > 0) {
            let { PageLoadData } = this.state;
            if (button == "1") {
                let indx = this.state.PageLoadDataBP.dataTable.findIndex((x) => x.ORDER_NO == this.state.OrderNo)
                PageLoadData.forEach((val, i) => {
                    PageLoadData[i].qty = parseInt(this.state.PageLoadDataBP.dataTable[i].QTY_REQUESTED)
                })

                this.state.Pickpopup.forEach((val, i) => {
                    let inx = this.state.Pickpopup.findIndex((x) => x.orderno == this.state.OrderNo)
                    this.state.Pickpopup.splice(inx, 1)
                })
                this.setState(PageLoadData);
                this.setState({
                    Pickpopup: [],
                })
                $(`#Pick_popup`).modal('hide')
            }
            else {
                //this.submitButtonClick(this.state.OrderNo, this.state.ItemId, this.state.LineNo)
                //let data = [];
                //let summ = [];
                //data = this.state.PageLoadData.filter((x) => x.Order_no == this.state.OrderNo)


                //data.map((x, i) => {
                //    let loc = {
                //        itemno: i + 1,
                //        ItemId: x.Inv_item_id,
                //        Location: x.Storage_Area + " " + x.Stor_level_1 + " " + x.Stor_level_2 + " " + x.Stor_level_3,
                //        OrderNo: x.Order_no
                //    }
                //    this.state.SummaryData.push(loc);
                //})
                //this.setState({ SummaryData: summ });
                $(`#summary`).modal('show')
                $(`#Pick_popup`).modal('hide')

            }
        }
    }
    /**
     * PC_PC_14
     * */

    submitButtonClick = (orderno, itemid, line_no) => {
        let data = [];
        let insertdata = [];
        let BP = [];
        console.log("itemdetailpicking", this.state.PageLoadData)
        if (itemid != "") {
            data = this.state.PageLoadData.filter((x) => x.ORDER_NO == orderno && x.INV_ITEM_ID == itemid && x.ORDER_INT_LINE_NO == line_no)
        }
        else {
            data = this.state.PageLoadData.filter((x) => x.ORDER_NO == this.state.SummaryData[0].OrderNo)
        }

        data.map((x, i) => {
            let loc = {
                Order_no: x.ORDER_NO,
                Qty_picked: x.qty == "" || x.qty == 0 ? 0 : x.qty,
                Pick_confirm_dttm: x.PICK_CONFIRM_DTTM,
                Qty_requested: x.QTY_REQUESTED,
                Begindttm: x.BEGINDTTM,
                Order_int_line_no: x.ORDER_INT_LINE_NO,
                Inv_item_id: x.INV_ITEM_ID,
                Demand_line_no: x.DEMAND_LINE_NO,
                Sched_line_no: x.SCHED_LINE_NO,
                Seq_nbr: x.SEQ_NBR,
                Recv_ln_nbr: x.RECV_LN_NBR,
                Demand_source: x.DEMAND_SOURCE,
                Receiver_id: x.RECEIVER_ID,
                Business_unit: x.BUSINESS_UNIT
            }
            insertdata.push(loc)
        })
        let BO = {
            UserId: CookieService.getLocalStorageValues("Session_UserID"),
            BusinessUnit: CookieService.getLocalStorageValues("Session_BUSUNIT"),
            ItemList: insertdata
        }
        $(`#${SDIConstants.SDILoader}`).removeClass('hide');
        PickingAction.SubmitButtonClick(BO)
    }
    /**
     * PP_PC_13
     * */
    DoneButtonClick = (val, bool) => {
        let data = [];
        let summ = [];
        if (bool == true) {
            data = this.state.PageLoadData.filter((x) => x.ORDER_NO == val.ORDER_NO && x.INV_ITEM_ID == val.INV_ITEM_ID && x.ORDER_INT_LINE_NO == val.ORDER_INT_LINE_NO)
        }
        else {
            data = this.state.PageLoadData.filter((x) => x.ORDER_NO == val)
        }

        data.map((x, i) => {
            let loc = {
                itemno: i + 1,
                ItemId: x.INV_ITEM_ID,
                Location: x.STORAGE_AREA + " " + x.STOR_LEVEL_1 + " " + x.STOR_LEVEL_2 + " " + x.STOR_LEVEL_3,
                OrderNo: x.ORDER_NO
            }
            summ.push(loc);
        })
        this.setState({ SummaryData: summ });
        if (this.state.Pickpopup.length > 0) {
            let pickpopuploc = this.state.Pickpopup.filter((x) => x.orderno == val)
            if (pickpopuploc.length > 0) {
                $(`#Pick_popup`).modal('show')
            }
            else {
                $('#summary').modal('show');
            }
        }
        else {
            $('#summary').modal('show');
        }

    }
    /**
     * PP_PC_20
     * */
    closebutton() {

        $('#summary').modal('hide');
        this.setState({ SummaryData: [] })
    }
    /**
     * PP_PC_19
     * */
    popupbody = () => {
        if (this.state.SummaryData.length > 0) {
            let pickorder = this.state.SummaryData[0].OrderNo
            let pickpopuploc = this.state.Pickpopup.filter((x) => x.orderno == pickorder)
            if (pickpopuploc.length > 1) {

                return pickpopuploc.map((x, i) => {
                    return (<>
                        <label className="w-100 confirm-label d-block" style={{ fontSize: "15px", width: "50%", float: "left" }}>{`${x.itemid} (${x.msg})`}</label>
                    </>)
                })
            }
            else {
                return pickpopuploc.map((x, i) => {
                    return (<>
                        <label className="w-100 confirm-label d-block" style={{ fontSize: "15px" }}>{`${x.itemid} (${x.msg})`}</label>
                    </>)
                })
            }
        }

    }
    /**
     * PP_PC_09
     * */

    SummaryBind = () => {
        return this.state.SummaryData.map((x, i) => {
            return (
                <div className="w-100 float-left mb-3 border-btm">
                    <h5 className="mb-2 txt-bold-menu txt-font px-3">{`Item ${x.itemno}`}</h5>
                    <div className="col-md-6 float-left">
                        <label className="catalog-label float-none"><Trans>Item ID</Trans><span> :</span></label>
                        <label className="item-details-value  float-none"> {x.ItemId}</label>
                    </div>
                    <div className="col-md-6 float-left">
                        <label className="catalog-label  float-none"><Trans>Location</Trans><span> :</span></label>
                        <label className="item-details-value float-none">{x.Location}</label>
                    </div>
                </div>
            );


        })
    }
    /**
     * PP_PC_08
     * */
    BindPickingOrder = () => {
        if (this.state.PageLoadData.length > 0) {
            let data = this.state.PageLoadData;
            let totalitems = 0;
            const uniqueTags = [];
            //[2/17/2023, PC_WW-614_APP_02, Dhevanesam R]
            let cribID = "";
            if (CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != null && CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT") != undefined) {
                cribID = "C" + CookieService.getLocalStorageValues("Session_ISA_CRIB_IDENT");
            }
            let PageLoadData = this.state.PageLoadData.filter((v, i, a) => a.findIndex(t => (t.ORDER_NO === v.ORDER_NO)) === i)
            console.log("filtered", this.state.PageLoadDataBP)
            if (this.state.OrderDetails.length > 0) {

                return this.state.OrderDetails.map((value, index) => {
                    //WW-773_PC_01 -Aparna
                    //PC_CPW_261_02 -Vishwa S
                    if (index < parseInt(this.state.PageNo) * 200 && index >= parseInt(this.state.PageNo - 1) * 200) {
                        let Value = this.state.PageLoadData.filter((x) => x.ORDER_NO == value.ORDER_NO)
                        totalitems = Value.length
                        let order_number = "";
                        //if (uniqueTags.indexOf(value.ORDER_NO) == -1) {
                        //    uniqueTags.push(value.ORDER_NO);
                        //    order_number = value.ORDER_NO;

                        //}

                        let locAssignToArr = [];
                        let assigntoobj = {};
                        if (Value[0].ASSIGNED_TO.trim() == "") {
                            assigntoobj = {
                                value: "0",
                                label: "Select User"
                            };
                        }
                        else if (Value[0].ASSIGNED_TO.trim().toUpperCase() == "SKIPPED") {
                            assigntoobj = {
                                value: "SKIPPED",
                                label: "SKIPPED"
                            };
                        }
                        else {
                            let locAssignTo = this.state.AssignToDD.filter((x) => x.value == Value[0].ASSIGNED_TO)
                            if (locAssignTo.length > 0) {
                                assigntoobj = {
                                    value: locAssignTo[0].value,
                                    label: locAssignTo[0].label
                                }
                            }
                            else {
                                assigntoobj = {
                                    value: "0",
                                    label: "Select User"
                                };
                            }
                        }
                        locAssignToArr.push(assigntoobj)
                        return (<React.Fragment key={index}>{/*order_number != "" ? <>*/}

                            <tr>
                                <td className="accordion-toggle" onClick={(e) => this.onAccordianClick(e, index)} >
                                    <span className="accordion-arrow header-arrow" id={`arrow-${index}`} />
                                </td>
                                <td>{Value[0].ORDER_NO}</td>
                                <td>{totalitems}</td>
                                {/*WW - 569 To add WO and change assign to name in the picking panel - Deepthi*/}
                                <td>{Value[0].ISA_WORK_ORDER_NO}</td>
                                <td>{Value[0].Priority}</td>
                                {/*[12/14/21, PC_PU_02, WW-291, Dhevanesam R]*/}
                                <td>{Value[0].BUSINESS_UNIT}</td>
                                <td>{Value[0].ORDER_DATE}</td>
                                <td className="dropdown-width-style">
                                    {/*PC_CPW_261_18 -Vishwa S */}
                                    <Select
                                        class="form-control rounded custom-grid-dropdown"
                                        id={`assignto-${index}`}
                                        name="AssignToID"
                                        onChange={(e) => this.handleAssignto(e, Value[0])}
                                        value={locAssignToArr}
                                        options={this.state.AssignToDD}
                                        classNamePrefix="react-select"
                                    />
                                    {/*[10/28/22], PC_WW-529_1, Dhevanesam R*/}
                                    {/*PC_CPW_261_18 -Vishwa S */}
                                    {/*<select id="AssignToID" className="form-control EmployeCC pr-0 PickAssignToDrop" value={Value[0].ASSIGNED_TO} onChange={(e) => this.handleAssignto(e, Value[0])}>
                                         <option value="0">{"Select User"}</option>
                                         <option value="SKIPPED">SKIPPED</option>{/*WW-733_PC_01 -Aparna*/}
                                    {/*{this.BindAssignTo()}
                                     </select>*/}
                                </td>
                            </tr>
                            <tr className="p d-none content-row" id={`contentrow-${index}`}>
                                <td colSpan={8} className="hiddenRow py-0">
                                    <div className="accordian-body  py-1" id="order-row-1">
                                        {this.LineData(Value[0].ORDER_NO)}
                                        {/*[10/28/22], PC_WW-529_13, Dhevanesam R*/}
                                        {/*PC_CPW_261_17 -Vishwa S */}
                                        {/*{Value[0].SubmitShow == true && Value[0].ButtonDisable == false ? <div className="col-md-6 mt-3 float-left p-0 mb-2" style={{ marginRight: "5rem" }}>*/}
                                        {/*[12/14/21, PC_PU_03, WW-291, Dhevanesam R]*/}
                                        {/*<button disabled={false} className="btn btn-primary custom-btn-primary primary-btn float-right px-5" data-toggle="modal" data-target="#submit" onClick={e => this.DoneButtonClick(Value[0].ORDER_NO, "")}><Trans>Submit</Trans></button>
                                      </div> : <div className="col-md-6 mt-3 float-left p-0 mb-2" style={{ marginRight: "5rem" }}>*/}
                                        {/*[12/14/21, PC_PU_03, WW-291, Dhevanesam R]*/}
                                        {/*<button disabled={true} className="btn btn-primary custom-btn-primary primary-btn float-right px-5" data-toggle="modal" data-target="#submit" onClick={e => this.DoneButtonClick(Value[0].ORDER_NO, "")}><Trans>Submit</Trans></button>
                                          </div>}*/}
                                    </div>
                                </td>

                            </tr>
                            {/* </> : null*/}
                        </React.Fragment>


                        );
                    }
                })
            }
            else {
                return (<>
                    <tr>
                        <td colspan="8">
                            <section className="site-undercontruction container text-center center-panel pt-4">
                                <div className="img-section">
                                    <img src="images/nosearch.jpg" alt="imagefile" />
                                </div>
                                <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                </p>
                            </section>
                        </td>
                    </tr></>
                );
            }
        }
    }
    //WW-773_PC_05 -Aparna
    handlePageClick = (data) => {
        let pageNo = data.selected + 1;
        this.setState({ PageNo: pageNo });
    }
    //PC_CPW_261_06 -Vishwa S
    getSearchText = (e) => {
        let searchVal = e.target.value;
        this.setState({ srchTxt: searchVal });
    }
    //PC_CPW_261_07 -Vishwa S
    STrDropDown = (event, displayName, columnName) => {
        event.preventDefault();
        this.setState({ SearchBy: columnName, STrDisplayName: displayName });
    }

    clearSearch = () => {
        let locDetails = this.state.OrgOrderDetails
        let totalcount = 0;
        let count = 0;
        if (locDetails.length > 0) {
            totalcount = locDetails.length
            count = parseFloat(totalcount) / 200
        }
        this.setState({ srchTxt: "", OrderDetails: locDetails, pageCount: count, Totalcount: totalcount })
    }
    //PC_CPW_261_08 -Vishwa S
    handleSearch = (event) => {
        //event.preventDefault();
        let searchDetail = [];
        let totalcount = 0;
        let count = 0;

        if (this.state.srchTxt.trim() !== '') {
            if (this.state.SearchBy === 'All') {
                searchDetail = this.state.OrgOrderDetails.filter(order =>
                    order.ISA_WORK_ORDER_NO === this.state.srchTxt.trim().toUpperCase() || order.ORDER_NO === this.state.srchTxt.trim().toUpperCase()
                );
            } else if (this.state.SearchBy === 'ISA_WORK_ORDER_NO') {
                searchDetail = this.state.OrgOrderDetails.filter(order =>
                    order.ISA_WORK_ORDER_NO === this.state.srchTxt.trim().toUpperCase()
                );
            } else if (this.state.SearchBy === 'ORDER_NO') {
                searchDetail = this.state.OrgOrderDetails.filter(order =>
                    order.ORDER_NO === this.state.srchTxt.trim().toUpperCase()
                );
            }
            if (searchDetail.length > 0) {
                totalcount = searchDetail.length;
                count = parseFloat(totalcount) / 200;
            }

            this.setState({
                OrderDetails: searchDetail,
                pageCount: count,
                Totalcount: totalcount,
                PageNo: 1
            });
        }
        else {
            let locOrderDetails = this.state.OrgOrderDetails
            totalcount = locOrderDetails.length;
            count = parseFloat(totalcount) / 200;

            this.setState({
                OrderDetails: locOrderDetails,
                pageCount: count,
                Totalcount: totalcount
            });
        }



    }
    //PC_CPW_261_09 -Vishwa S
    keyPress = (e) => {
        if (e.keyCode == 13) {
            this.handleSearch(e)
        }
    }
    //PC_CPW_261_10-15 -Vishwa S
    sortData = (property, srchBy) => {
        let sortedData = [...this.state.OrderDetails]; // Shallow copy of OrderDetails

        if (property === "ISA_CUST_PRIORITY") {
            sortedData.sort((a, b) => {
                let valA = a.ISA_CUST_PRIORITY != null ? a.ISA_CUST_PRIORITY : '';
                let valB = b.ISA_CUST_PRIORITY != null ? b.ISA_CUST_PRIORITY : '';
                if (srchBy === "ASC") {
                    if (valA === '' && valB !== '') return 1;
                    if (valB === '' && valA !== '') return -1;
                    return valA.localeCompare(valB);
                }
                else if (srchBy === "DESC") {
                    if (valA === '' && valB !== '') return -1;
                    if (valB === '' && valA !== '') return 1;
                    return valB.localeCompare(valA);
                }
            });

        } else if (property === "ORDER_DATE") {
            sortedData.sort((a, b) => {
                let partsA = a.ORDER_DATE.split('-');
                let partsB = b.ORDER_DATE.split('-');
                let dateA = new Date(parseInt(partsA[2]), parseInt(partsA[0]) - 1, parseInt(partsA[1]));
                let dateB = new Date(parseInt(partsB[2]), parseInt(partsB[0]) - 1, parseInt(partsB[1]));

                if (srchBy === "ASC") {
                    return dateA - dateB;
                } else if (srchBy === "DESC") {
                    return dateB - dateA;
                }
            });
        }

        this.setState({ OrderDetails: sortedData });
    }

    LineData = (Ord_no) => {

        let data = this.state.PageLoadData;
        let lineitemdata = data.filter((x) => x.ORDER_NO == Ord_no)
        return this.state.PageLoadData.filter((x) => x.ORDER_NO == Ord_no).map((value, index) => {
            let qt = parseInt(value.QTY_REQUESTED)
            let imgpath;
            if (value.IMAGEURL == "" || value.IMAGEURL == "\\N") {
                imgpath = `/Images/noimage_new.png`
            }
            else {
                imgpath = value.IMAGEURL
            }

            return (
                <React.Fragment key={index}>

                    <div class="px-3 py-3">
                        <div class="row item-box custom-bg py-3">
                            <div class="col-md-12">
                                <div class="d-flex flex-wrap flex-lg-nowrap">
                                    <div className="image-resp-width">
                                        <img class="cart-product-img-style" src={imgpath} alt="Item Image" />
                                    </div>
                                    <div className="w-100">
                                        <div className="row">
                                            <div className="col-md-12 responsive-spacing-style">
                                                <div className="w-100">
                                                    <h5 className="font-16 font-bold mb-3 text-dark">{value.INV_ITEM_ID}</h5>
                                                </div>
                                                <div className="row">
                                                    <div class="col-md-12 mb-3">
                                                        <label class="font-12 font-regular label-value-color text-nowrap mb-0">{value.DESCR254}</label>
                                                    </div>
                                                    <div className="col-lg-3 col-md-12 mb-3">
                                                        <label className="font-12 font-medium label-color mb-0"><Trans>Line</Trans><span> # :</span></label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0">{value.ORDER_INT_LINE_NO}</label>
                                                    </div>
                                                    <div className="col-lg-3 col-md-12 mb-3">
                                                        <label className="font-12 font-medium label-color mb-0"><Trans>Location</Trans><span> :</span></label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0">{`${value.STORAGE_AREA} ${value.STOR_LEVEL_1} ${value.STOR_LEVEL_2} ${value.STOR_LEVEL_3} ${value.STOR_LEVEL_4}`}</label>
                                                    </div>
                                                    <div class="col-lg-3 col-md-12 mb-3">
                                                        <label class="font-12 font-medium label-color mb-0"><span>Qty </span><Trans>Requested</Trans><span> :</span></label>
                                                        <label class="ml-2 font-12 font-regular label-value-color mb-0">{qt}</label>
                                                    </div>
                                                    <div className="col-lg-3 col-md-12 mb-3">
                                                        <label className="font-12 font-medium label-color mb-0"><Trans>Reserved Qty</Trans><span> :</span></label>
                                                        <label className="ml-2 font-12 font-regular label-value-color mb-0">{value.qty}</label>
                                                    </div>
                                                    <div className="col-md-12">
                                                        <label className="font-12 font-medium label-color mb-0"><Trans>Customer Notes</Trans><span> :</span></label>
                                                        <label className="font-12 font-regular label-value-color mb-0">{value.ISA_CUST_NOTES}</label>
                                                    </div>
                                                </div>

                                                {/* <div className="col-md-12 mt-3 float-left p-0 mb-2">
                                <button className="btn btn-primary custom-btn-primary primary-btn float-right px-5" data-target="#submit" onClick={(e) => this.qtycheck(e, value)}>Done</button>
                             </div>*/}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            );
        })
    }
    render() {
        return (
            <>
                <div className="container-fluid content-section">
                    <div className="row">
                        <div className="container-fluid content-margin Ord-title m-2" >
                            <div className="row">
                                <div className="col-md-12 page-heading my-3">
                                    <h5 className="page-title"><Trans>Picking Assign To</Trans></h5>
                                    <div className="fav-item-maintenance-icon mt-1">
                                        <input type="checkbox" id="checkbox-OrdStatus" className="checknow" name="isFavorited" checked={this.state.isFavorited} onChange={this.handleFavorite} />
                                        <label htmlFor="checkbox-OrdStatus">
                                            <svg className="heart-svg" viewBox="467 392 58 57" xmlns="http://www.w3.org/2000/svg">
                                                <g className="Group" fill="none" fillRule="evenodd" transform="translate(467 392)">
                                                    <path d="M29.144 20.773c-.063-.13-4.227-8.67-11.44-2.59C7.63 28.795 28.94 43.256 29.143 43.394c.204-.138 21.513-14.6 11.44-25.213-7.214-6.08-11.377 2.46-11.44 2.59z" className="heart" fill="#fff" />
                                                    <circle className="main-circ" fill="#E2264D" opacity={0} cx="29.5" cy="29.5" r="1.5" />
                                                    <g className="grp7" opacity={0} transform="translate(7 6)">
                                                        <circle className="oval1" fill="#9CD8C3" cx={2} cy={6} r={2} />
                                                        <circle className="oval2" fill="#8CE8C3" cx={5} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp6" opacity={0} transform="translate(0 28)">
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={7} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={3} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp3" opacity={0} transform="translate(52 28)">
                                                        <circle className="oval2" fill="#9CD8C3" cx={2} cy={7} r={2} />
                                                        <circle className="oval1" fill="#8CE8C3" cx={4} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp2" opacity={0} transform="translate(44 6)">
                                                        <circle className="oval2" fill="#CC8EF5" cx={5} cy={6} r={2} />
                                                        <circle className="oval1" fill="#CC8EF5" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp5" opacity={0} transform="translate(14 50)">
                                                        <circle className="oval1" fill="#91D2FA" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#91D2FA" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp4" opacity={0} transform="translate(35 50)">
                                                        <circle className="oval1" fill="#F48EA7" cx={6} cy={5} r={2} />
                                                        <circle className="oval2" fill="#F48EA7" cx={2} cy={2} r={2} />
                                                    </g>
                                                    <g className="grp1" opacity={0} transform="translate(24)">
                                                        <circle className="oval1" fill="#9FC7FA" cx="2.5" cy={3} r={2} />
                                                        <circle className="oval2" fill="#9FC7FA" cx="7.5" cy={2} r={2} />
                                                    </g>
                                                </g>
                                            </svg>
                                        </label>
                                    </div>
                                </div>
                                {this.state.PageLoadData.length > 0 ?
                                    <div className="col-md-12">
                                        <div class="d-grid d-md-flex justify-content-md-end align-items-center grid-resp-style my-3">
                                            <div>
                                                <div class="input-group dropdown-search w-100">
                                                    <div class="input-group-prepend">
                                                        <button class="btn btn-outline-secondary dropdown-toggle font-14" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{this.state.STrDisplayName}</button>
                                                        <div class="dropdown-menu">
                                                            <a class="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "All", "All")}>All</a>
                                                            <a class="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Order #", "ORDER_NO")}>Order #</a>
                                                            <a class="dropdown-item" href="#" onClick={(e) => this.STrDropDown(e, "Work order", "ISA_WORK_ORDER_NO")}>Work order</a>
                                                        </div>
                                                    </div>
                                                    <input type="text" class="form-control" placeholder="Search" maxLength="11" value={this.state.srchTxt} onChange={(e) => this.getSearchText(e)} onKeyDown={this.keyPress} aria-label="Text input with dropdown button" />
                                                    <span className={this.state.srchTxt != null && this.state.srchTxt.trim() != "" ? "search-cancel-header cursor-pointer" : "d-none"} style={{ "float": "left" }} onClick={() => this.clearSearch()}></span>
                                                    <a><span class="dropdown-search-icon" onClick={(e) => this.handleSearch(e)}></span></a>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="table-responsive table-scroll-style mt-2">
                                            <table className="table ZEUS_Grid FOM-grid mobileresponsive-grid text-nowrap">
                                                <thead class="sticky-top custom-overlay">
                                                    <tr>
                                                        <th></th>
                                                        <th className="position-sort-icon"><Trans>Order </Trans> <span>#</span></th>
                                                        <th className="position-sort-icon"><Trans>Total items</Trans></th>
                                                        {/*WW - 569 To add WO and change assign to name in the picking panel - Deepthi*/}
                                                        <th className="position-sort-icon"><Trans>Work order</Trans></th>
                                                        <th className="position-sort-icon"><Trans>Priority</Trans><span class="sort-up ml-1"><img src="Images/sort2.svg" alt="sort-up" onClick={() => this.sortData("ISA_CUST_PRIORITY", "ASC")} /></span><span class="sort-down ml-1"><img src="Images/sort1.svg" alt="sort-down" onClick={() => this.sortData("ISA_CUST_PRIORITY", "DESC")} /></span></th>
                                                        {/*[12/14/21, PC_PU_01, WW-291, Dhevanesam R]*/}
                                                        <th className="position-sort-icon"><Trans>Crib identifier</Trans></th>
                                                        <th className="position-sort-icon"><Trans>Order date</Trans><span class="sort-up ml-1"><img src="Images/sort2.svg" alt="sort-up" onClick={() => this.sortData("ORDER_DATE", "ASC")} /></span><span class="sort-down ml-1"><img src="Images/sort1.svg" alt="sort-down" onClick={() => this.sortData("ORDER_DATE", "DESC")} /></span></th>
                                                        <th className="position-sort-icon"><Trans>Assign To</Trans></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {this.BindPickingOrder()}


                                                </tbody>
                                            </table>
                                        </div>
                                    </div> : (<section className="site-undercontruction container text-center center-panel pt-4">
                                        <div className="img-section">
                                            <img src="images/nosearch.jpg" alt="imagefile" />
                                        </div>
                                        <p className="search-result-content pt-4"><Trans>No Records found</Trans>
                                        </p>
                                    </section>)}
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12">
                        <div className="d-flex justify-content-end">
                            {this.state.Totalcount > 0 ? <>

                                <div className="col-md-12">
                                    <span className="total-records mt-2 d-inline-block">
                                        <Trans>Number of Records</Trans><span>:</span><span className="ml-2">{this.state.Totalcount}</span>
                                    </span>
                                    {this.state.Totalcount > this.state.RecCount ? <ReactPaginate
                                        previousLabel={<span className="right-pagination-arrow" />}
                                        nextLabel={<span className="left-pagination-arrow" />}
                                        previousClassName={'page-item'}
                                        nextClassName={'page-item'}
                                        previousLinkClassName={'page-link'}
                                        nextLinkClassName={'page-link'}
                                        disabledClassName={'disabled'}
                                        breakLabel={'...'}
                                        breakClassName={'page-item'}
                                        breakLinkClassName={'page-link'}
                                        pageCount={this.state.pageCount}
                                        marginPagesDisplayed={1}
                                        pageRangeDisplayed={2}
                                        onPageChange={this.handlePageClick}
                                        containerClassName={'custom-pagination pagination float-right'}
                                        pageClassName={'page-item'}
                                        pageLinkClassName={'page-link'}
                                        activeClassName={'active'}
                                        hrefBuilder={() => '#'}
                                        forcePage={this.state.PageNo - 1}
                                    /> : null}
                                </div></> : null}
                        </div>
                    </div>
                </div>
                <div className="modal" id="summary">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header" >
                                <h4 className="modal-title mt-1"><Trans>Summary</Trans></h4>

                            </div>
                            {/* Modal body */}
                            <div className="modal-body">
                                <div className="row justify-content-center">
                                    <div className="col-md-11 content-w-auto">
                                        {this.SummaryBind()}



                                    </div>
                                </div>
                                <div className="col-md-12 text-center mb-2 mt-3">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" onClick={e => this.closebutton()} ><Trans>Cancel</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" onClick={e => this.submitButtonClick("", "", "")}><Trans>Confirm</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal" id="Pick_popup">
                    <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                        <div className="modal-content">
                            {/* Modal Header */}
                            <div className="modal-header">
                                <h4 className="modal-title mt-1" />

                            </div>
                            {/* Modal body */}

                            <div className="modal-body text-center">
                                <div className="col-12 my-5">
                                    {/*<label className="confirm-label d-block">{this.state.Pick}</label>*/}
                                    {this.popupbody()}
                                    <label className="confirm-content d-block">{`Do you really want to pick ${this.state.Pick} the Item?`}</label>
                                </div>

                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-5" data-dismiss="modal" onClick={e => this.Pickpopup("1")}><Trans>No</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-5" data-dismiss="modal" data-toggle="modal" onClick={e => this.Pickpopup("2")}><Trans>Yes</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );

    };
}
export default withTranslation()(MMPickupOrderComponent);